import { SHIPMENT_DELIVERY_TERM } from 'app_config';

export const SHIPMENT_PLAN_FILTER_FIELDS = (countryOptions = []) => [
  {
    key:        'name',
    label:      'Phase name',
    type:       'text',
    placeholder:'Phase name...',
    paramKey:   'name_cont',
    tagName:    'Phase name',
  },
  {
    key:        'job_number',
    label:      'Job number',
    type:       'text',
    placeholder:'e.g. J03547/25',
    paramKey:   'project_j_number_cont',
    tagName:    'Job number',
  },
  {
    key:        'project_name',
    label:      'Project name',
    type:       'text',
    placeholder:'Project name...',
    paramKey:   'project_name_cont',
    tagName:    'Project name',
  },
  {
    key:        'cse_incharge',
    label:      'CSE incharge',
    type:       'text',
    placeholder:'CSE name...',
    paramKey:   'cse_incharge_cont',
    tagName:    'CSE incharge',
  },
  // ── divider after cse_incharge ──
  {
    key:        'delivery_term',
    label:      'Delivery term',
    type:       'multiselect',
    options:    SHIPMENT_DELIVERY_TERM.map((v) => ({ value: v, label: v })),
    paramKey:   'project_delivery_term_in',
    tagName:    'Delivery term',
  },
  {
    key:        'destination_port',
    label:      'Destination port',
    type:       'text',
    placeholder:'Port name...',
    paramKey:   'project_destination_port_cont',
    tagName:    'Destination port',
  },
  {
    key:        'location',
    label:      'Location',
    type:       'multiselect',
    options:    countryOptions,
    paramKey:   'project_pj_country_in',
    tagName:    'Location',
  },
  // ── divider after location ──
  {
    key:       'confirmed_date',
    label:     'Confirmed date',
    type:      'date_range',
    paramKeys: ['confirmed_date_gteq', 'confirmed_date_lteq'],
    tagName:   'Confirmed date',
  },
  {
    key:       'etd',
    label:     'ETD',
    type:      'date_range',
    paramKeys: ['etd_gteq', 'etd_lteq'],
    tagName:   'ETD',
  },
  // ── divider after etd ──
  {
    key:        'created_by',
    label:      'Created by',
    type:       'text',
    placeholder:'Username...',
    paramKey:   'user_name_cont',
    tagName:    'Created by',
  },
  {
    key:       'created_at',
    label:     'Created date',
    type:      'date_range',
    paramKeys: ['created_at_gteq', 'created_at_lteq'],
    tagName:   'Created date',
  },
];

export const SHIPMENT_PLAN_DIVIDERS = ['cse_incharge', 'location', 'etd'];
